/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Norwegian (Bokmål)
export default {
  'proforma-jira-portal-create.error-flag-handler.portal-create-view-object-search-error-description':
    'Be teamet eller administratoren din om hjelp.',
  'proforma-jira-portal-create.error-flag-handler.portal-create-view-object-search-error-title':
    'Vi kan ikke hente resultater for dette søket',
};
